/**
 * 登录注册相关接口
 */
import request from './request'

/**
 * 个人账号登录
 * @param {object} params - { loginName, password, loginType }
 */
export function memberLogin(params) {
  return request.post('/api/member/login', params)
}

/**
 * 企业账号登录
 * @param {object} params - { loginName, password, loginType }
 */
export function companyLogin(params) {
  return request.post('/api/company/login', params)
}

/**
 * 个人账号注册
 * @param {object} data - { mobile, code, password, nickname }
 */
export function memberRegister(data) {
  return request.post('/api/member/register', data)
}

/**
 * 企业账号注册
 * @param {object} data - { companyName, loginName, password, code }
 */
export function companyRegister(data) {
  return request.post('/api/company/register', data)
}

/**
 * 个人账号获取短信验证码
 * @param {object} params - { areaCode, mobile }
 */
export function memberGetMessage(params) {
  return request.post('/api/member/getMessage', params)
}

/**
 * 企业账号获取短信验证码
 * @param {object} params - { areaCode, mobile }
 */
export function companyGetMessage(params) {
  return request.post('/api/company/getMessage', params)
}

/**
 * 个人忘记密码（重置密码）
 * @param {object} data - { mobile, code, password }
 */
export function memberResetPassword(data) {
  return request.post('/api/member/forgotPassword', data)
}

/**
 * 企业忘记密码（重置密码）
 * @param {object} data - { mobile, code, password }
 */
export function companyResetPassword(data) {
  return request.post('/api/company/forgotPassword', data)
}

/**
 * 获取验证码图片
 * @returns Promise - { code, uuid, img: base64 } 
 */
export function getCaptchaImage() {
  return request.get('/api/captchaImage')
}
